import { httpGet, httpPost, httpDelete, httpGetFile } from './api.service';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { ChangeLog } from '../types/ChangeLog';
import { Label } from '../types/Label';
import { PaginatedResult } from '../types/PaginatedResult';
import { Result } from '../types/Result';

const getLabels = async (request: PaginatedRequest): Promise<Result<Label>> => {
  return await httpGet<Result<Label>>(`api/label`, request);
};

const addOrUpdateLabel = async (request: Label): Promise<boolean> => {
  return await httpPost(`api/label`, request);
};

const deleteLabel = async (id: string): Promise<boolean> => {
  return await httpDelete(`api/label/${id}`);
};

const getLabelChangeLog = async (id: string, request: PaginatedRequest): Promise<PaginatedResult<ChangeLog>> => {
  return await httpGet(`api/label/${id}/changeLog`, request);
};

const exportLabels = async (request: any): Promise<void> => {
  return await httpGetFile(`api/label/export`, request);
};

export { getLabels, addOrUpdateLabel, deleteLabel, getLabelChangeLog, exportLabels };
